<template>
    <ks-flex classes="input-group">
        <div class="input-group-prepend">
          <slot/>
        </div>
    </ks-flex>
</template>
  
<script>
  export default {
    name: 'ks-group'
  }
</script>
